import React from "react";

import { IconCalendarOutlined } from "~/components/icon";
import type { Time } from "~/tools/date-time/time";

import { FormatViewTime } from "./react/viewtime/FormatViewTime";

export interface TimestampProps {
	time: Time;
}

export const Timestamp: React.FC<TimestampProps> = ({ time }) => (
	<div className="flex shrink-0 flex-row items-center gap-2 rounded-xs border border-grey-400 border-solid bg-grey-200 px-3 font-normal text-13 text-grey-600">
		<IconCalendarOutlined />
		<FormatViewTime time={time} />
	</div>
);
